import { escapeHtml } from './html'

const DOCUMENT_STYLE = `
    body {
      margin: 0;
      padding: 32px 24px;
      background-color: #f8fafc;
      color: #0f172a;
      font-family: 'Inter', ui-sans-serif, system-ui, sans-serif;
      font-size: 14px;
    }
    .report {
      max-width: 1200px;
      margin: 0 auto;
    }
    .report-title {
      margin: 0 0 4px;
      font-size: 22px;
      font-weight: 600;
    }
    .report-subtitle {
      margin: 0 0 12px;
      color: #64748b;
      font-size: 13px;
    }
    .filter-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 6px;
      margin-bottom: 20px;
    }
    .filter-tag {
      display: inline-flex;
      align-items: baseline;
      gap: 5px;
      padding: 3px 10px;
      border: 1px solid #e2e8f0;
      border-radius: 9999px;
      background-color: #ffffff;
      font-size: 12px;
    }
    .filter-tag-label {
      color: #64748b;
    }
    .filter-tag-value {
      font-weight: 500;
    }
    .card {
      background-color: #ffffff;
      border: 1px solid #e5e7eb;
      border-radius: 12px;
      padding: 20px;
      margin-bottom: 20px;
    }
    .card-title {
      margin: 0 0 16px;
      font-size: 15px;
      font-weight: 600;
    }
    .kpi-row {
      display: flex;
      gap: 10px;
    }
    .kpi-item {
      flex: 1 1 0;
      min-width: 0;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 10px 12px;
    }
    .kpi-label {
      display: block;
      color: #64748b;
      font-size: 11px;
      line-height: 1.3;
      margin-bottom: 4px;
    }
    .kpi-value {
      display: block;
      font-size: 17px;
      font-weight: 600;
    }
    .status-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
    .status-item {
      display: flex;
      align-items: center;
      gap: 10px;
      flex: 1 1 180px;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 10px 12px;
    }
    .status-dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      flex-shrink: 0;
    }
    .status-label {
      flex: 1 1 auto;
      color: #334155;
      font-size: 13px;
    }
    .status-count {
      font-size: 15px;
      font-weight: 600;
    }
    table {
      width: 100%;
      border-collapse: collapse;
    }
    thead th {
      background-color: #f8fafc;
      border-bottom: 2px solid #e5e7eb;
      padding: 10px 12px;
      font-size: 12px;
      font-weight: 600;
      color: #475569;
      text-align: center;
    }
    tbody td {
      border-bottom: 1px solid #f1f5f9;
      padding: 10px 12px;
      font-size: 13px;
      text-align: center;
    }
    .text-left {
      text-align: left;
    }
    .th-info {
      position: relative;
      display: inline-flex;
      vertical-align: middle;
      margin-left: 4px;
      color: #94a3b8;
      cursor: help;
    }
    .th-info-bubble {
      position: absolute;
      bottom: calc(100% + 8px);
      left: 50%;
      transform: translateX(-50%);
      width: 260px;
      padding: 10px 12px;
      border-radius: 8px;
      background-color: #0f172a;
      color: #ffffff;
      font-size: 12px;
      font-weight: 400;
      line-height: 1.5;
      text-align: left;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.15s ease 1s, visibility 0s linear 1.15s;
      z-index: 10;
    }
    .th-info-bubble a {
      color: #93c5fd;
    }
    .th-info:hover .th-info-bubble {
      opacity: 1;
      visibility: visible;
      transition: opacity 0.15s ease, visibility 0s;
    }
    thead th:last-child .th-info-bubble {
      left: auto;
      right: 0;
      transform: none;
    }
    .empty {
      color: #64748b;
      font-size: 13px;
    }`

function renderFilterTags (filters) {
  return filters
    .map(filter => `
        <span class="filter-tag">
          <span class="filter-tag-label">${escapeHtml(filter.label)}</span>
          <span class="filter-tag-value">${escapeHtml(filter.value)}</span>
        </span>`)
    .join('')
}

function renderKpiItems (kpis) {
  return kpis
    .map(kpi => `
          <div class="kpi-item">
            <span class="kpi-label">${escapeHtml(kpi.label)}</span>
            <span class="kpi-value">${escapeHtml(kpi.value)}</span>
          </div>`)
    .join('')
}

function renderStatusItems (statuses) {
  if (statuses.length === 0) {
    return '<p class="empty">Nenhuma chamada no período selecionado.</p>'
  }
  return `<div class="status-grid">${statuses
    .map(status => `
          <div class="status-item">
            <span class="status-dot" style="background-color: ${escapeHtml(status.color)};"></span>
            <span class="status-label">${escapeHtml(status.label)}</span>
            <span class="status-count">${escapeHtml(status.count)}</span>
          </div>`)
    .join('')}</div>`
}

// O tooltip é HTML fixo definido nas colunas da tabela (inclui link), por isso
// entra sem escape — igual ao v-html usado na tela.
function renderColumnInfo (tooltip) {
  if (tooltip === undefined) return ''
  return `<span class="th-info"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" /></svg><span class="th-info-bubble">${tooltip}</span></span>`
}

function renderTable (columns, rows) {
  if (rows.length === 0) {
    return '<p class="empty">Nenhum usuário com chamadas no período selecionado.</p>'
  }
  const head = columns
    .map(column => `<th${column.leftAlign ? ' class="text-left"' : ''}>${escapeHtml(column.label)}${renderColumnInfo(column.tooltip)}</th>`)
    .join('')
  const body = rows
    .map(row => `
            <tr>${row
    .map((cell, index) => `<td${columns[index].leftAlign ? ' class="text-left"' : ''}>${escapeHtml(cell)}</td>`)
    .join('')}</tr>`)
    .join('')
  return `
        <table>
          <thead>
            <tr>${head}</tr>
          </thead>
          <tbody>${body}
          </tbody>
        </table>`
}

export function generateDashboardReportHtml (report) {
  return `<!DOCTYPE html>
<html lang="pt-BR">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Desempenho por usuário — ${escapeHtml(report.organizationName)}</title>
    <style>${DOCUMENT_STYLE}
    </style>
  </head>
  <body>
    <div class="report">
      <h1 class="report-title">Desempenho por usuário</h1>
      <p class="report-subtitle">${escapeHtml(report.organizationName)} · Gerado em ${escapeHtml(report.generatedAt)}</p>
      <div class="filter-tags">${renderFilterTags(report.filters)}
      </div>

      <div class="card">
        <h2 class="card-title">Resumo do período</h2>
        <div class="kpi-row">${renderKpiItems(report.kpis)}
        </div>
      </div>

      <div class="card">
        <h2 class="card-title">Distribuição por status de chamadas</h2>
        ${renderStatusItems(report.statuses)}
      </div>

      <div class="card">
        <h2 class="card-title">Desempenho por usuário</h2>
        ${renderTable(report.columns, report.rows)}
      </div>
    </div>
  </body>
</html>`
}



// WEBPACK FOOTER //
// ./src/utils/dashboardReportHtml.js